export default __webpack_public_path__ + "de4c2beeaf8c2e9d7e828c1912760355.svg";